<script>
    import { curveStep, line, scaleLinear } from "d3";
    import { canvasSize, offset, USE_IMAGE_SMOOTHING } from "../previewstores.js";

    let canvasWidth = $canvasSize;
    let width = canvasWidth;

    let height = 200;
    let margin = { top: 8, bottom: 8, left: 0, right: 0 };

    // The component will draw a line based on an array beamhardCrossData of {x, y} objects
    export let beamhardCrossData = [
        { x: 0, y: 90 },
        { x: 1, y: 20 },
        { x: 2, y: 10 },
        { x: 3, y: 30 },
        { x: 4, y: 40 },
        { x: 5, y: 50 },
        { x: 6, y: 25 },
        { x: 7, y: 20 },
        { x: 8, y: 80 },
        { x: 9, y: 100 },
        { x: 10, y: 90 },
        { x: 11, y: 20 },
        { x: 12, y: 10 },
        { x: 13, y: 30 },
        { x: 14, y: 40 },
        { x: 15, y: 50 },
        { x: 16, y: 25 },
        { x: 17, y: 20 },
        { x: 18, y: 80 },
        { x: 19, y: 100 },
    ];

    let el;

    // Scale the graph to same width as the image and *height* pixels high
    let xScale = scaleLinear()
        .domain([0, canvasWidth])
        .range([margin.left, width - margin.right]);
    let yScale = scaleLinear()
        .domain([0, 100])
        .range([height - margin.bottom, margin.top]);

    // This function returns the svg path
    let path = line()
        .x((d) => xScale(d.x))
        .y((d) => yScale(d.y))
        .curve(curveStep);
    let xPath;
    let yPath;

    function initGraphAxes() {
        xPath = `M${margin.left + 0.5},6V0H${width - margin.right + 1}V6`;
        yPath = `M-6,${height + 0.5}H0.5V0.5H-6`;
    }

    export let beamhardCrossY = 255;
    export let canvas;

    $: {
        canvasWidth = $canvasSize;
        width = canvasWidth;
        initGraphAxes();
    }
    $: updateCrossData(canvas);

    async function updateCrossData(updatedCanvas) {
        if (!updatedCanvas) {
            console.log("EMPTY CANVAS IN BEAMHARDGRAPH COMPONENT");
            return;
        }
        let sctx = updatedCanvas.getContext("2d");
        sctx.imageSmoothingEnabled = $USE_IMAGE_SMOOTHING;
        var y = beamhardCrossY || canvasWidth / 2 - 1;
        var pixel = sctx.getImageData(-$offset.x, -$offset.y + y, canvasWidth, 1);
        var data = pixel.data;
        //DEBUG: console.log("CALLED UPDATE CROSS DATA. PIXEL DATA: ", data);

        let rowData = [];
        data.forEach((p, ix) => {
            if (ix % 4 == 0) rowData.push({ x: ix / 4, y: (p / 256) * 100 });
        });
        //DEBUG: console.log("ROW DATA: ", rowData);
        beamhardCrossData = rowData;
    }
</script>

<beamhard-graph style="--canvasWidth:{canvasWidth}px" width={canvasWidth}>
    <svg bind:this={el} transform="translate({margin.left}, {margin.top})">
        <g>
            <path d={path(beamhardCrossData)} fill="none" stroke="blue" />
        </g>

        <g transform="translate({margin.left}, 0)">
            <path stroke="currentColor" d={yPath} fill="none" />
        </g>

        <g transform="translate(0, {height})">
            <path stroke="currentColor" d={xPath} fill="none" />
        </g>
    </svg>
</beamhard-graph>

<style>
    beamhard-graph {
        margin-top: 40px;
        height: 200px;
        display: flex;
        width: var(--canvasWidth);
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 16px;
    }

    beamhard-graph svg {
        display: block;
        width: 100%;
        background-color: var(--var-theme-base-background-color);
    }
</style>
